export default __webpack_public_path__ + "static/media/features-thumb.65a0832e.webp";